import { render, staticRenderFns } from "./swNews.vue?vue&type=template&id=459f5e07&scoped=true"
import script from "./swNews.vue?vue&type=script&lang=js"
export * from "./swNews.vue?vue&type=script&lang=js"
import style0 from "./swNews.vue?vue&type=style&index=0&id=459f5e07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f5e07",
  null
  
)

export default component.exports